import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "./IndretFormulari.module.css";
import IndretFormulariFoto from "./IndretFormulariFoto";
import IndretDetallFoto from "./IndretDetallFoto";
import ErrorBoundaryWrapper from "../commons/ErrorBoundaryWrapper";
import { Select, Input, DatePicker, InputNumber } from "antd";
import { modificarValorBooleanPerTextSiNo } from "../commons/TaulaOrdenacioCerca";
import PopOverError from "../commons/PopOverError";
import {
  indretIntroduccioModificarCamp,
  setTitolApartat,
  obtenirObservadorsLlistat,
  inicialitzarIndret
} from "../../actions";
import {
  getDadesEditadesIndret,
  getDadesOriginalsIndret,
  getMostrarErrorsIndret,
  getObservadorsUsuari,
  getIndretFotosOriginals
} from "../../reducers";
import {
  TEXT_QUAN_NO_HI_HA_DADA,
  TITOL_CREAR_INDRET,
  TITOL_EDITAR_INDRET,
  TITOL_DADES_INDRET,
  INDRETS_ORIENTACIO,
  INDRETS_CLIMA,
  VALOR_MAX_DESCRIPCIO_INDRET,
  NUM_DECIMALS_DISTACIA_MAR,
  DISTANCIA_MAR_MIN,
  DISTANCIA_MAR_MAX
} from "../../constantsFormularis";
import VariableLlista from "../commons/variableLlista";
import {
  MASCARA_DDMMYYYY,
  MASCARA_YYYYMMDD,
  convertirTextAMomentUTC
} from "../../utils/dates";
import { obtenirErrorsDadesIndret } from "../../utils/formularis";
import { NotificacioError } from "../Notification";

const nomCampObservador = "nomObservador";
const nomCampIdObservador = "idObservador";
const nomCampNomIndret = "nom";
const nomCampCanvis = "canvis";
const nomCampClima = "clima";
const nomCampDataBaixa = "dataBaixa";
const nomCampDescripcio = "descripcio";
const nomCampDistanciaMar = "distanciaMar";
const nomCampOrientacio = "orientacio";
const nomCampPaisatge = "paisatge";
const nomCampRelleu = "relleu";

const renderitzarError = errorCamp => {
  if (errorCamp) {
    return <PopOverError contingut={errorCamp} classNameIcona="icona-error" />;
  }
  // és necessari retornar un div buit i no null perquè cssGrid ho interpreti com a contingut
  return <div />;
};

const obtenirValorsAmbFormatPelSelector = valors => {
  let id = 0;
  return valors.map(valor => ({ id: ++id, valor: valor }));
};

const renderitzarCampTipusNumber = (
  nomCamp,
  esEditable,
  valor,
  indretIntroduccioModificarCamp
) => {
  if (!esEditable) {
    // si hi ha valor, sempre es passa a string perquè així ens assegurem que si és una variable booleana aparegui
    return valor ? valor.toString() : TEXT_QUAN_NO_HI_HA_DADA;
  }
  return (
    <InputNumber
      aria-labelledby={"id-" + nomCamp}
      min={DISTANCIA_MAR_MIN}
      max={DISTANCIA_MAR_MAX}
      step={1 / Math.pow(10, NUM_DECIMALS_DISTACIA_MAR)}
      onChange={distaciaMar =>
        indretIntroduccioModificarCamp(nomCamp, distaciaMar)}
      value={valor}
      precision={NUM_DECIMALS_DISTACIA_MAR}
    />
  );
};

const renderitzarCampTipusText = (
  nomCamp,
  esEditable,
  valor,
  indretIntroduccioModificarCamp
) => {
  if (!esEditable) {
    // si hi ha valor, sempre es passa a string perquè així ens assegurem que si és una variable booleana aparegui
    return valor ? valor.toString() : TEXT_QUAN_NO_HI_HA_DADA;
  }

  return (
    <Input
      aria-labelledby={"id-" + nomCamp}
      defaultValue={valor}
      onBlur={event => {
        const valor = event.target.value;
        indretIntroduccioModificarCamp(nomCamp, valor ? valor : null);
      }}
    />
  );
};

const renderitzarCampTipusTextArea = (
  nomCamp,
  esEditable,
  valor,
  indretIntroduccioModificarCamp
) => {
  const { TextArea } = Input;

  if (!esEditable) {
    // si hi ha valor, sempre es passa a string perquè així ens assegurem que si és una variable booleana aparegui
    return valor ? valor.toString() : TEXT_QUAN_NO_HI_HA_DADA;
  }

  return (
    <TextArea
      aria-labelledby={"id-" + nomCamp}
      className={styles.indretDescripcioCamp}
      autoSize={{ minRows: 3, maxRows: 5 }}
      onChange={event => {
        const valor = event.target.value;
        indretIntroduccioModificarCamp(nomCamp, valor ? valor : null);
      }}
      maxLength={VALOR_MAX_DESCRIPCIO_INDRET}
      value={valor}
      disabled={!esEditable}
    />
  );
};

const renderitzarCampTipusLlista = (
  nomCamp,
  esEditable,
  valor,
  valorsPossibles,
  indretIntroduccioModificarCamp
) => {
  if (!esEditable) {
    const valorCercat = valorsPossibles.find(
      valorPossible => valorPossible.nom === valor
    );

    return valorCercat && valorCercat.valor ? valorCercat.valor : valor;
  }

  const estilsSelector = {
    selector: styles.indretLlistatSelector
  };

  const variable = { id: nomCamp, nom: null, valor, valorsPossibles };

  return (
    <VariableLlista
      estils={estilsSelector}
      variable={variable}
      label={nomCamp}
      onChangeValorVariable={valor => {
        const valortext = valorsPossibles.filter(
          element => element.id === valor
        );
        indretIntroduccioModificarCamp(nomCamp, valortext[0].valor);
      }}
      allowClear={false}
    />
  );
};

const renderitzarCampTipusData = (
  nomCamp,
  esEditable,
  valor,
  indretIntroduccioModificarCamp
) => {
  const dataSeleccionadaText = valor;
  const dataSeleccionada = dataSeleccionadaText
    ? convertirTextAMomentUTC(dataSeleccionadaText, MASCARA_YYYYMMDD)
    : null;

  if (!esEditable) {
    return dataSeleccionada
      ? dataSeleccionada.format(MASCARA_DDMMYYYY)
      : TEXT_QUAN_NO_HI_HA_DADA;
  }

  return (
    <DatePicker
      className={styles.indretFormulariData}
      defaultValue={dataSeleccionada}
      onChange={date => {
        const dataText = date ? date.format(MASCARA_YYYYMMDD) : null;
        indretIntroduccioModificarCamp(nomCamp, dataText);
      }}
      format={MASCARA_DDMMYYYY}
    />
  );
};

class IndretFormulari extends Component {
  state = {
    disableComponents: false
  };

  componentDidMount() {
    const { esEditable, dadesOriginals } = this.props;

    if (esEditable) {
      this.obtenirObservadors();
    }

    const esNouIndret =
      dadesOriginals[nomCampIdObservador] === null ? true : false;

    if (esNouIndret) {
      this.props.inicialitzarIndret();
    }

    this.props.setTitolApartat(
      esNouIndret
        ? TITOL_CREAR_INDRET
        : esEditable
          ? TITOL_EDITAR_INDRET
          : !esEditable ? TITOL_DADES_INDRET : ""
    );
  }

  obtenirObservadors = () => {
    this.props
      .obtenirObservadorsLlistat()
      .then(dades => {
        if (dades.error && dades.error.message) {
          return NotificacioError("Avís", dades.error.message);
        }
      })
      .catch(error => {
        if (error.message && error.titol) {
          return NotificacioError(error.titol, error.message);
        }
      });
  };

  disableComponent = value => {
    this.setState({ disableComponents: value });
  };

  renderitzarComponentSegonsTipus(
    nomCamp,
    esEditable,
    tipusCamp,
    valorsPossibles
  ) {
    const {
      dadesEditades,
      dadesOriginals,
      indretIntroduccioModificarCamp
    } = this.props;

    const valor = esEditable
      ? dadesEditades && dadesEditades[nomCamp] ? dadesEditades[nomCamp] : null
      : dadesOriginals && dadesOriginals[nomCamp]
        ? dadesOriginals[nomCamp]
        : null;

    switch (tipusCamp) {
      case "number": {
        return renderitzarCampTipusNumber(
          nomCamp,
          esEditable,
          valor,
          indretIntroduccioModificarCamp
        );
      }

      case "text": {
        return renderitzarCampTipusText(
          nomCamp,
          esEditable,
          valor,
          indretIntroduccioModificarCamp
        );
      }

      case "boolean": {
        return renderitzarCampTipusText(
          nomCamp,
          esEditable,
          modificarValorBooleanPerTextSiNo(valor),
          indretIntroduccioModificarCamp
        );
      }

      case "llista": {
        return renderitzarCampTipusLlista(
          nomCamp,
          esEditable,
          valor,
          valorsPossibles,
          indretIntroduccioModificarCamp
        );
      }

      case "data": {
        return renderitzarCampTipusData(
          nomCamp,
          esEditable,
          valor,
          indretIntroduccioModificarCamp
        );
      }

      case "textarea": {
        return renderitzarCampTipusTextArea(
          nomCamp,
          esEditable,
          valor,
          indretIntroduccioModificarCamp
        );
      }

      default:
        return null;
    }
  }

  renderitzarComponentFloat(nomCamp, esEditable) {
    return this.renderitzarComponentSegonsTipus(nomCamp, esEditable, "float");
  }

  renderitzarComponentText(nomCamp, esEditable) {
    return this.renderitzarComponentSegonsTipus(nomCamp, esEditable, "text");
  }

  renderitzarComponentNumber(nomCamp, esEditable) {
    return this.renderitzarComponentSegonsTipus(nomCamp, esEditable, "number");
  }

  renderitzarComponentTextArea(nomCamp, esEditable) {
    return this.renderitzarComponentSegonsTipus(
      nomCamp,
      esEditable,
      "textarea"
    );
  }

  renderitzarComponentLlista(nomCamp, valorsPossibles, esEditable) {
    return this.renderitzarComponentSegonsTipus(
      nomCamp,
      esEditable,
      "llista",
      valorsPossibles
    );
  }

  renderitzarComponentData(nomCamp, esEditable) {
    return this.renderitzarComponentSegonsTipus(nomCamp, esEditable, "data");
  }

  renderitzarCampObservador() {
    const {
      dadesEditades,
      esEditable,
      observadors,
      indretIntroduccioModificarCamp
    } = this.props;
    const { Option } = Select;

    const idObservadorSeleccionat =
      dadesEditades && dadesEditades[nomCampIdObservador] !== null
        ? dadesEditades[nomCampIdObservador]
        : "";

    if (!esEditable) {
      return dadesEditades ? dadesEditades.nomObservador : "";
    }

    if (!observadors || !Array.isArray(observadors)) {
      return "";
    }

    const llistaObservadorSeleccionat = observadors.filter(observador => {
      return observador.id === parseInt(idObservadorSeleccionat);
    });

    const nomObservadorSeleccionat =
      llistaObservadorSeleccionat && llistaObservadorSeleccionat.length > 0
        ? `${llistaObservadorSeleccionat[0].nom
            ? llistaObservadorSeleccionat[0].nom
            : ""} ${llistaObservadorSeleccionat[0].cognom1
            ? llistaObservadorSeleccionat[0].cognom1
            : ""} ${llistaObservadorSeleccionat[0].cognom2
            ? llistaObservadorSeleccionat[0].cognom2
            : ""}`
        : "";

    const valor =
      idObservadorSeleccionat && nomObservadorSeleccionat
        ? `${nomObservadorSeleccionat}#&${idObservadorSeleccionat}`
        : "";

    const idCamp = `id-${nomCampObservador}`;
    return (
      <Select
        showSearch
        placeholder="Selecciona un observador..."
        style={{ width: "100%", maxHeight: 100 }}
        aria-labelledby={idCamp}
        onChange={valorSeleccionat => {
          const idObservador = valorSeleccionat.substr(
            valorSeleccionat.indexOf("#&") + 2
          );
          const nomObservador = valorSeleccionat.substr(
            0,
            valorSeleccionat.indexOf("#&")
          );
          indretIntroduccioModificarCamp(
            nomCampIdObservador,
            String(idObservador)
          );
          indretIntroduccioModificarCamp(
            nomCampObservador,
            String(nomObservador)
          );
        }}
        value={valor ? valor : ""}
      >
        {observadors.map(observador => {
          const nomObservador = `${observador.nom
            ? observador.nom
            : ""} ${observador.cognom1
            ? observador.cognom1
            : ""} ${observador.cognom2 ? observador.cognom2 : ""}`;
          return (
            <Option
              key={observador.id}
              value={`${nomObservador}#&${observador.id}`}
            >
              {nomObservador}
            </Option>
          );
        })}
      </Select>
    );
  }

  renderitzarComponentImatge(fotosUrl, esEditable, dadesEditades) {
    if (esEditable) {
      return (
        <IndretFormulariFoto
          fotosUrl={fotosUrl}
          dadesObservador={dadesEditades}
          onDisableComponent={this.disableComponent}
        />
      );
    } else {
      return <IndretDetallFoto fotos={fotosUrl} />;
    }
  }

  renderitzarSeccioDadesIndret() {
    const {
      esEditable,
      dadesEditades,
      dadesOriginals,
      fotosOriginals,
      errors,
      mostrarErrors
    } = this.props;

    if (!esEditable && dadesOriginals[nomCampIdObservador] === null) {
      return null;
    }

    const esNouIndret =
      dadesOriginals[nomCampIdObservador] === null ? true : false;

    const mostrarDataBaixa =
      dadesEditades && dadesEditades.dataBaixa
        ? dadesEditades.dataBaixa
        : false;

    let llistaErrors = [];
    if (mostrarErrors) {
      llistaErrors = errors;
    }
    const orientacionsAmbFormatPelSelector = obtenirValorsAmbFormatPelSelector(
      INDRETS_ORIENTACIO
    );
    const climesAmbFormatPelSelector = obtenirValorsAmbFormatPelSelector(
      INDRETS_CLIMA
    );

    const errorCampNomObservador = llistaErrors[nomCampObservador];
    const errorCampNomIndret = llistaErrors[nomCampNomIndret];
    const errorCampCanvis = llistaErrors[nomCampCanvis];
    const errorCampClima = llistaErrors[nomCampClima];
    const errorCampDataBaixa = llistaErrors[nomCampDataBaixa];
    const errorCampDescripcio = llistaErrors[nomCampDescripcio];
    const errorCampDistanciaMar = llistaErrors[nomCampDistanciaMar];
    const errorCampOrientacio = llistaErrors[nomCampOrientacio];
    const errorCampPaisatge = llistaErrors[nomCampPaisatge];
    const errorCampRelleu = llistaErrors[nomCampRelleu];

    const fotosUrl = fotosOriginals ? fotosOriginals : [];

    return (
      <div className={styles.indretDades}>
        <div>
          <span id={"id-" + nomCampObservador} className={styles.label}>
            Observador:
          </span>
          <div>{this.renderitzarCampObservador()}</div>
          {renderitzarError(errorCampNomObservador)}
        </div>

        <div className={styles.Indret}>
          <span id={"id-" + nomCampNomIndret} className={styles.label}>
            Indret:
          </span>
          <div>
            {this.renderitzarComponentText(nomCampNomIndret, esEditable)}
          </div>
          {renderitzarError(errorCampNomIndret)}
        </div>

        <div>
          <span id={"id-" + nomCampDescripcio} className={styles.label}>
            Descripció:
          </span>
          <div>
            {this.renderitzarComponentTextArea(nomCampDescripcio, esEditable)}
          </div>
          {renderitzarError(errorCampDescripcio)}
        </div>

        <div>
          <span id={"id-" + nomCampRelleu} className={styles.label}>
            Relleu:
          </span>
          <div>{this.renderitzarComponentText(nomCampRelleu, esEditable)}</div>
          {renderitzarError(errorCampRelleu)}
        </div>

        <div>
          <span id={"id-" + nomCampDistanciaMar} className={styles.label}>
            Distància al mar (km):
          </span>
          <div>
            {this.renderitzarComponentNumber(nomCampDistanciaMar, esEditable)}
          </div>
          {renderitzarError(errorCampDistanciaMar)}
        </div>

        <div>
          <span id={"id-" + nomCampPaisatge} className={styles.label}>
            Paisatge:
          </span>
          <div>
            {this.renderitzarComponentText(nomCampPaisatge, esEditable)}
          </div>
          {renderitzarError(errorCampPaisatge)}
        </div>

        <div>
          <span id={"id-" + nomCampOrientacio} className={styles.label}>
            Orientació:
          </span>
          <div>
            {this.renderitzarComponentLlista(
              nomCampOrientacio,
              orientacionsAmbFormatPelSelector,
              esEditable
            )}
          </div>
          {renderitzarError(errorCampOrientacio)}
        </div>

        <div>
          <span id={"id-" + nomCampClima} className={styles.label}>
            Clima:
          </span>
          <div>
            {this.renderitzarComponentLlista(
              nomCampClima,
              climesAmbFormatPelSelector,
              esEditable
            )}
          </div>

          {renderitzarError(errorCampClima)}
        </div>

        <div>
          {mostrarDataBaixa ? (
            <span id={"id-" + nomCampDataBaixa} className={styles.label}>
              Data de baixa:
            </span>
          ) : null}
          {mostrarDataBaixa ? (
            <div>
              {this.renderitzarComponentData(
                nomCampDataBaixa,
                esEditable && esNouIndret
              )}
            </div>
          ) : null}
          {mostrarDataBaixa ? renderitzarError(errorCampDataBaixa) : null}
        </div>

        {!esNouIndret ? (
          <div>
            <span id={"id-" + nomCampCanvis} className={styles.label}>
              Canvis:
            </span>
            <div>
              {this.renderitzarComponentTextArea(nomCampCanvis, esEditable)}
            </div>
            {renderitzarError(errorCampCanvis)}
          </div>
        ) : null}

        <div className={styles.Pdte}>
          <span className={styles.label}>Fotos:</span>
          {this.renderitzarComponentImatge(fotosUrl, esEditable, dadesEditades)}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={styles.indretFormulari + " " + styles.camp}>
        {this.renderitzarSeccioDadesIndret()}
      </div>
    );
  }
}

IndretFormulari.propTypes = {
  esEditable: PropTypes.bool,
  history: PropTypes.object,
  indretIntroduccioModificarCamp: PropTypes.func,
  observadors: PropTypes.array,
  dadesEditades: PropTypes.object,
  dadesOriginals: PropTypes.object,
  errors: PropTypes.object,
  setTitolApartat: PropTypes.func.isRequired,
  inicialitzarIndret: PropTypes.func.isRequired,
  fotos: PropTypes.array,
  obtenirObservadorsLlistat: PropTypes.func
};

const mapStateToProps = state => {
  return {
    dadesEditades: getDadesEditadesIndret(state),
    dadesOriginals: getDadesOriginalsIndret(state),
    fotosOriginals: getIndretFotosOriginals(state),
    errors: obtenirErrorsDadesIndret(state.indrets.formulari.editades),
    mostrarErrors: getMostrarErrorsIndret(state),
    observadors: getObservadorsUsuari(state)
  };
};

const mapDispatchToProps = {
  setTitolApartat,
  inicialitzarIndret,
  indretIntroduccioModificarCamp,
  obtenirObservadorsLlistat
};

export default ErrorBoundaryWrapper(
  connect(mapStateToProps, mapDispatchToProps)(IndretFormulari)
);
